<template>
    <footer class="footer fixed-bottom py-2">
        <div class="container-fluid">
            King's University College - 2021
        </div>
    </footer>
</template>

<script>
export default {
    name: 'student-footer'
}
</script>

<style scoped>
.footer {
    background-color: #003f36;
    color: #fff;
}
</style>